import axios from 'axios'
import * as actions from '../constants'

export const loadPost = (_id) => dispatch=>{
  dispatch({
    type: actions.LOAD_POST_REQUEST
  })
  axios.get('/posts/'+_id).then(({data})=>{
    dispatch({
      type: actions.LOAD_POST_SUCCESS,
      payload: data
    })
  }).catch(error=>{
    dispatch({
      type: actions.LOAD_POST_FAILURE,
      payload: error.message
    })
  })
}

export const createComment = (comment) => dispatch=>{
  dispatch({
    type: actions.CREATE_COMMENT_REQUEST
  })
  axios.post('/comments', comment).then(({data})=>{
    dispatch({
      type: actions.CREATE_COMMENT_SUCCESS,
      payload: data
    })
  }).catch(error=>{
    dispatch({
      type: actions.CREATE_COMMENT_FAILURE,
      payload: error.message
    })
  })
}



// WEBPACK FOOTER //
// ./src/actions/post.js